import { render, staticRenderFns } from "./TenantsWidgetPanel.vue?vue&type=template&id=5694a1d6&scoped=true"
import script from "./TenantsWidgetPanel.vue?vue&type=script&lang=js"
export * from "./TenantsWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./TenantsWidgetPanel.vue?vue&type=style&index=0&id=5694a1d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5694a1d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5694a1d6')) {
      api.createRecord('5694a1d6', component.options)
    } else {
      api.reload('5694a1d6', component.options)
    }
    module.hot.accept("./TenantsWidgetPanel.vue?vue&type=template&id=5694a1d6&scoped=true", function () {
      api.rerender('5694a1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/TenantsWidgetPanel.vue"
export default component.exports